import { createSvgIcon } from '@mui/material';

const IconThumbUp = createSvgIcon(
  <path d="M1 21h4V9H1v12zM23 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 2 7.58 8.59C7.22 8.95 7 9.45 7 10v9c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.85-1.22l3.02-7.05c.09-.23.13-.47.13-.73v-1.2l-.01-.02L23 10z" />,
  'thumb_up'
);

export default IconThumbUp;
